export const BELT_RANKS = [
  { name: 'White Belt', threshold: 0, color: '#f8fafc', stripe: '#e5e7eb', text: '#111827' },
  { name: 'Blue Belt', threshold: 25, color: '#3b82f6', stripe: '#93c5fd', text: '#ffffff' },
  { name: 'Purple Belt', threshold: 50, color: '#8b5cf6', stripe: '#c4b5fd', text: '#ffffff' },
  { name: 'Brown Belt', threshold: 100, color: '#92400e', stripe: '#d97706', text: '#ffffff' },
  { name: 'Black Belt', threshold: 250, color: '#111827', stripe: '#6b7280', text: '#ffffff' }
];

export const getBeltForSessions = (count = 0) => {
  let current = BELT_RANKS[0];
  for (const belt of BELT_RANKS) {
    if (count >= belt.threshold) current = belt;
  }
  return current;
};
